// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"8ce6df56","278":"8bdaec40","359":"d293d91c","896":"9632197b"}[chunkId] + ".chunk.js";
};